import { createActionTypes } from 'lib/utils/createActionTypes';

interface IUIModalDuckState {
  isOpen: boolean;
  content: null | any;
  title: string | null;
  controls: any[] | null;
}

export default class UIModalDuck {
  public static initialState: IUIModalDuckState = {
    isOpen: false,
    content: null,
    title: null,
    controls: []
  };

  public static duckName = "UI/Modal";

  public static actionTypes: any = createActionTypes(
    {
      isOpen: "is_open",
      openModal: "open_modal",
      closeModal: "close_modal"
    },
    UIModalDuck.duckName
  );

  /**
   * Used to open Modal, set it's content and color
   */
  public static openModal = (
    content: any,
    title: string = "",
    controls: any[] = []
  ) => dispatch => {
    document.body.classList.add("Modal-open");
    dispatch({
      type: UIModalDuck.actionTypes.openModal,
      payload: { content, title, controls, isOpen: true }
    });
  };

  /**
   * Used to close Modal, set it's content and color
   */
  
  public static closeModal = () => dispatch => {
    document.body.classList.remove("Modal-open");
    dispatch({
      type: UIModalDuck.actionTypes.closeModal,
      payload: {}
    });
  };

  public static getOwnState = (state: IUIModalDuckState) =>
    state[UIModalDuck.duckName] || UIModalDuck.initialState;

  public static isOpen(state) {
    return this.getOwnState(state).isOpen;
  }

  public static reducer(state = UIModalDuck.initialState, action) {
    switch (action.type) {
      case UIModalDuck.actionTypes.openModal:
        return {
          ...action.payload,
          isOpen: true
        };
      case UIModalDuck.actionTypes.closeModal:
        // console.log("IN HERERERE");
        return {
          isOpen: false,
          content: null,
          title: null,
          controls: []
        };
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ducks/ui/UIModal.duck.ts